import { C } from "@angular/cdk/keycodes";
import { Injectable } from "@angular/core";
import { TemplateService } from "./template.service";
import { TemplateMasterService } from "../master_modules/masters/apps/template/template-master.service";
import { BUTTON_SHAPE, BUTTON_TYPE, BannerSectionComponent, Corners, EventsService } from "simpo-component-library";
import { environment } from "src/environments/environment";
import { HttpClient } from "@angular/common/http";


@Injectable({
  providedIn: 'root'
})

export class WebsiteEditor {
  constructor(private templateService: TemplateMasterService,
    private eventService: EventsService,
    private http: HttpClient,
  ) { }

  addSection(pageData: any, response: any, component: any) {
    let index: number = response.position === 'ABOVE' ? response.index : response.index + 1;
    pageData.components.splice(index, 0, component);
  }

  deleteSection(pageData: any, index: number) {
    pageData.components.splice(index, 1);
  }

  regenerateContent(subIndustryId: string, sectionId: string, component: any) {
    this.templateService.getSectionContent(sectionId, subIndustryId).subscribe((res: any) => {
      component.content = res.data;
    })
  }

  positionChange(pageData: any, response: any) {
    let index = response.index;
    let swappedIndex = response.movingDirection === 'UP' ? response.index - 1 : response.index + 1;

    [pageData.components[index], pageData.components[swappedIndex]] = [pageData.components[swappedIndex], pageData.components[index]];
  }

  duplicateComponent(pageData: any, response: any) {
    let duplicateComponent = JSON.parse(JSON.stringify(response.data));
    pageData.components.splice(response.index + 1, 0, duplicateComponent);
  }

  textAlign = ['left', 'center', 'right']
  imageRatio = ['1:1', '2:3', '3:2', '16:9']
  textPosition = ['Below image', 'On top of image', 'Covering image'];
  footerType = ['Split Details Right', 'Split Details Left', 'Stacked Details Right', 'Stacked Details Center', 'Stacked Details Left', 'Simple Details Right', 'Simple Details Center']
  regenerateComponent(component: any) {
    if (component.sectionType === 'banner' || component.sectionType === 'text_image') {
      let index = component.styles.positionLayout.types.indexOf(component.styles.positionLayout.value) + 1;
      component.styles.positionLayout.value = component.styles.positionLayout.types[index % component.styles.positionLayout.types.length];
    }
    if (component.sectionType === 'FAQ' || component.sectionType === 'testimonial' || component.sectionType === 'text') {
      let index = this.textAlign.indexOf(component.styles.layout.align) + 1;
      component.styles.layout.align = this.textAlign[index % this.textAlign.length];
    }
    if (component.sectionType === 'imagegrid') {
      if (!component.styles.removeGaps || !component.styles.fullWidth) {
        component.styles.removeGaps = true;
        component.styles.fullWidth = true;
      } else {
        let index = this.imageRatio.indexOf(component.styles.image.ratio) + 1;
        component.styles.image.ratio = this.imageRatio[index % this.imageRatio.length];
      }
    }
    if (component.sectionType === 'image') {
      if (!component.styles.fullWidth) {
        component.styles.fullWidth = true
      }
    }
    if (component.sectionType === 'service' || component.sectionType === 'teammember') {
      let index = this.textPosition.indexOf(component.styles.textPosition) + 1;
      component.styles.textPosition = this.textPosition[index % this.textPosition.length];
    }
    if (component.sectionType === 'video') {
      component.styles.fullScreen = !component.styles.fullScreen;
      if (component.styles.layout.fit === 'content') {
        component.styles.layout.fit = 'screen'
      } else {
        component.styles.layout.fit = 'content'
      }
    }
    if (component.sectionType === 'footer') {
      let index = this.footerType.indexOf(component.styles.footerType) + 1;
      component.styles.footerType = this.footerType[index % this.footerType.length];
    }
  }

  applyGlobalThemeColor(theme: any, templatePage: any[]) {
    for (let page of templatePage) {
      let themeIndex: number = 0;
      page.websiteThemeId = theme.id;


      for (let component of page.components) {
        let color = theme.componentStyles[themeIndex % theme.componentStyles.length].bgColor
        let accentColor = theme.componentStyles[themeIndex % theme.componentStyles.length].accentColor

        if (component?.styles?.background) {
          component.styles.background.color = color;
          component.styles.background.accentColor = accentColor;
          this.eventService.backgroundImageChangeCheck.emit({ id: component.id, data: component.styles.background })
          themeIndex++;
        }
      }
    }

  }

  changeGlobalButtonStyle(style: number, type: BUTTON_TYPE, shape: BUTTON_SHAPE, templatePage: any[]) {
    for (let page of templatePage) {
      for (let component of page.components) {
        if (component.action && component.action.buttons
          && component.action.buttons[style - 1]) {
          component.action.buttons[style - 1].styles.type = type;
          component.action.buttons[style - 1].styles.shape = shape;

          this.eventService.buttonStyleChangeChecks.emit({ id: component.id + component.action.buttons[style - 1].id, style: component.action.buttons[style - 1].styles, backgroundInfo: component.styles.background })
        }
      }
    }
  }

  changeGlobalAnimation(animationType: string, animatonSpeed: string, templatePage: any[]) {
    for (let page of templatePage) {
      for (let component of page.components) {
        if (component?.styles?.animation) {
          component.styles.animation.type = animationType;
          component.styles.animation.speed = animatonSpeed;

          this.eventService.animationChangeChecks.emit({ id: component.id, data: component.styles.animation })
        }
      }
    }
  }

  changeGlobalCorners(corner: Corners, templatePage: any[]) {
    for (let page of templatePage) {
      for (let component of page.components) {
        if (component?.styles?.corners) {
          component.styles.corners = corner;
          this.eventService.cornerChangeChecks.emit({ id: component.id, size: component.styles.corners })
        }
      }
    }
  }

  changeCustomColor(oldColor: string, newColor: string, accentColor: string, templatePage: any) {
    for (let page of templatePage) {
      for (let component of page.components) {
        if (component?.styles?.background && component.styles.background.color === oldColor) {
          component.styles.background.color = newColor;
          component.styles.background.accentColor = accentColor;
          this.eventService.backgroundImageChangeCheck.emit({ id: component.id, data: component.styles.background })
        }
      }
    }
  }
}
